/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from 'moment'
import { Power, Pencil, PowerOff } from "lucide-react";
import Page from '../../../components/Page';
import Modal from '../../../components/modal/Index';
import AddContentWriterForm from './AddContentWriterForm';
import SnackBar from '../../../components/snackbar/snackbar';
import adminServices from '../../../services/adminServices';

const statusConfig = {
    "Active": {
        label: "Active",
        className: "bg-emerald-50 text-emerald-700 border border-emerald-200",
        dot: "bg-emerald-500",
        pulse: true,
    },
    "In Active": {
        label: "In Active",
        className: "bg-gray-100 text-gray-500 border border-gray-200",
        dot: "bg-gray-400",
        pulse: false,
    },
    "On Maintenance": {
        label: "On Maintenance",
        className: "bg-gray-100 text-gray-500 border border-gray-200",
        // className: "bg-amber-50 text-amber-800 border border-amber-200",
        dot: "bg-amber-500",
        pulse: false,
    },
};

function StatusBadge({ status }) {
    const config = statusConfig[status] || statusConfig["In Active"];
    return (
        <span className={`inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-md tracking-wide ${config.className}`}>
            <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${config.dot} ${config.pulse ? "animate-pulse" : ""}`} />
            {
                config.label === 'Active'
                    ? 'Live'
                    : config.label === 'In Active'
                        ? 'Draft'
                        : 'MAINTENANCE'
            }
        </span>
    );
}

function SectionTable({ title, count, children }) {
    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2.5">
                <h2 className="text-sm font-semibold text-gray-800 tracking-tight">{title}</h2>
                <span className="w-5 h-5 rounded-full bg-gray-100 text-gray-500 text-xs font-medium flex items-center justify-center">
                    {count}
                </span>
            </div>
            <div className="overflow-x-auto">{children}</div>
        </div>
    );
}

export default function ContentCreatorProfile() {
    const location = useLocation()

    const [modalOpen, setModalOpen] = useState(false);
    const navigate = useNavigate()
    const [hovered, setHovered] = useState(null);
    const [deactivateAlert, setDeactivateAlert] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarTitle, setSnackbarTitle] = useState('');
    const [userStatus, setUserStatus] = useState(location.state?.user_status);
    const [deactivateUser, setDeactivateUser] = useState({ id: null, name: '' });
    const [details, setDetails] = useState('');

    const [name, setName] = useState({id:location?.state?.id, first_name: location?.state?.first_name?.trim(), last_name: location?.state?.last_name?.trim(), email: location?.state?.email })

    const navigateBack = () => {
        navigate('/app/content-writer-details')
    }

    const updateDetails = (data) => {        
        const firstName = data?.firstName?.trim();
        const lastName = data?.lastName?.trim();
        const email = data?.email;
        setName({
            first_name: firstName,
            last_name: lastName,
            email
        });
    };


    const handleOpenDeactivateModal = (row, message) => {
        const name = `${row.first_name || ''} ${row.last_name || ''}`.trim();
        setDeactivateUser({ id: row.id, name });
        setDetails(message)
        setDeactivateAlert(true);
    };


    function DeactivateModal({ open, userName, onConfirm, onCancel }) {
        if (!open) return null;
        return (
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    backgroundColor: 'rgba(0,0,0,0.35)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1300,
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderRadius: 12,
                        padding: '32px 28px 24px',
                        width: 380,
                        maxWidth: '90vw',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    }}
                >
                    <h2
                        style={{
                            margin: '0 0 10px',
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                        }}
                    >
                        {details === 'Deactivate' ? 'Deactivate Content Creator' : "Reactivate Content Creator"}
                    </h2>
                    <p
                        style={{
                            margin: '0 0 28px',
                            fontSize: 14,
                            color: '#4B5563',
                            lineHeight: 1.6,
                        }}
                    >
                        {details === 'Deactivate' ? (
                            <>
                                <strong>{userName}</strong> will lose access to the platform.
                                <br />
                                Their content will not be affected.
                            </>
                        ) : (
                            <>
                                <strong>{userName}</strong> will regain access to the platform.
                            </>
                        )}
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                        <button
                            onClick={onCancel}
                            style={{
                                padding: '9px 22px',
                                fontSize: 14,
                                fontWeight: 500,
                                color: '#374151',
                                backgroundColor: '#fff',
                                border: '1px solid #d1d5db',
                                borderRadius: 8,
                                cursor: 'pointer',
                                fontFamily: 'inherit',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f3f4f6' }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff' }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => onConfirm(details)}
                            className={details === 'Deactivate' ?
                                "inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold transition-all"
                                : "inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-all"}

                        // style={{
                        //     padding: '9px 22px',
                        //     fontSize: 14,
                        //     fontWeight: 600,
                        //     color: '#fff',
                        //     backgroundColor: details === 'Deactivate' ? '#E11D48' : '#004DE5',
                        //     border: 'none',
                        //     borderRadius: 8,
                        //     cursor: 'pointer',
                        //     fontFamily: 'inherit',
                        // }}
                        // onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#be123c' }}
                        // onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#E11D48' }}
                        >
                            {details === 'Deactivate' ? 'Deactivate' : 'Reactivate'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const handleDeactivate = async (data) => {
        const status = data === 'Deactivate' ? 'Delete' : 'Active'

        try {
            const res = await adminServices.deleteContentWriterList(location.state.id, status);

            if (res.ok) {
                setSnackbarTitle(`${data} Successfully`);
                setUserStatus('Delete');
                // setName({firstname:location?.state?.first_name,lastname:location?.state?.last_name,email:location?.state?.email})
                navigate('/app/content-writer-details')
            } else {
                setSnackbarTitle(res.data.error);
            }

            setOpenSnackbar(true);
            setDeactivateAlert(false);
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <Page title={'ContentWriter'}>
            <div
                className="min-h-screen bg-[#F5F5F3] p-6 md:p-10"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
                <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');`}</style>

                <div className="max-w-5xl mx-auto space-y-5">
                    <button onClick={navigateBack} className="inline-flex items-center gap-1.5 text-sm text-gray-400 hover:text-gray-700 transition-colors">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                        Content Creators
                    </button>

                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                            <div className="flex items-center gap-4">

                                <div>
                                    {/* <h1 className="text-xl font-semibold text-gray-900 leading-tight">{location?.state?.first_name}{location?.state?.last_name}</h1> */}
                                    <h1 className="text-xl font-semibold text-gray-900 leading-tight">
                                        {[name?.first_name, name?.last_name]
                                            .filter(Boolean)
                                            .join(' ')}
                                    </h1>
                                    <p className="text-sm text-gray-400 mt-0.5">{name?.email}</p>
                                    <div className="flex flex-wrap items-center gap-2 mt-2">
                                        <span
                                            className="text-xs font-medium text-white bg-gray-900 px-2 py-0.5 rounded-md tracking-widest"
                                            style={{ fontFamily: "'DM Mono', monospace" }}
                                        >
                                            CONTENT_CREATOR
                                        </span>
                                        <span
                                            className={`inline-flex items-center px-3 py-0.5 rounded-full text-xs font-semibold border ${location?.state?.user_status !== 'Delete'
                                                ? 'text-green-700 bg-green-50 border-green-200'
                                                : 'text-[#71717A] bg-[#71717A]/10 border-[#71717A]/30'
                                                }`}
                                        >
                                            {location?.state?.user_status === 'Delete' ? 'InActive' : location?.state?.user_status}
                                        </span>

                                        <span className="text-xs text-gray-400">Joined {location?.state?.create_datetime ? moment(location?.state?.create_datetime).format('MMM DD, YYYY') : '-'} </span>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-2 flex-shrink-0">
                                <button onClick={() => setModalOpen(true)} className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-700 border border-gray-200 bg-white px-4 py-2 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm">
                                    <Pencil size={18} />
                                    <span>Edit</span>
                                </button>

                                {userStatus !== 'Delete' ?
                                    <button onClick={() => handleOpenDeactivateModal(location.state, 'Deactivate')}
                                        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-500 hover:text-red-600 border border-red-200 hover:border-red-300 text-sm font-semibold transition-all"

                                    // className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all
                                    // ${userStatus
                                    //         ? 'bg-red-600 hover:bg-red-700 text-white'
                                    //         : 'bg-blue-600 hover:bg-blue-700 text-white'
                                    //     }`}

                                    >
                                        {userStatus ? (
                                            <>
                                                <PowerOff size={16} />
                                                <span>Deactivate</span>
                                            </>
                                        ) : (
                                            <>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
                                                <span>Activate</span>
                                            </>
                                        )}
                                    </button>
                                    :
                                    <button onClick={() => handleOpenDeactivateModal(location.state, 'Reactivate')}
                                        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-500 hover:text-blue-600 border border-blue-200 hover:border-blue-300 text-sm font-semibold transition-all"

                                    // className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-all"
                                    >
                                        {userStatus ? (
                                            <>
                                                <Power size={22} />
                                                <span>Reactivate</span>
                                            </>
                                        ) : (
                                            <>

                                                <span>Activate</span>
                                            </>
                                        )}
                                    </button>
                                }
                                {/* {userStatus !== 'Delete' ? (
                                    <button onClick={() => handleOpenDeactivateModal(row, 'Deactivate')}
                                    className={`flex items-center gap-1 text-sm font-medium transition-colors ${isActive ? 'text-red-500 hover:text-red-700' : 'text-green-600 hover:text-green-800'
                                      }`}
                                  >
                                    {isActive ? (
                                      <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></svg>
                                        <span>{t('Deactivate')}</span>
                                      </>
                                    ) : (
                                      <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
                                        <span>{t('Activate')}</span>
                                      </>
                                    )}
                                  </button>)
                                  :
                                  <button onClick={() => handleOpenDeactivateModal(row, 'Reactivate')}
                                    className={`flex items-center gap-1 text-sm font-medium transition-colors text-blue-600 hover:text-blue-800
                                    }`}
                                  >
                                    {isActive ? (
                                      <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></svg>
                                        <span>{t('Reactivate')}</span>
                                      </>
                                    ) : (
                                      <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
                                        <span>{t('Activate')}</span>
                                      </>
                                    )}
                                  </button>
                                } */}
                            </div>
                        </div>
                    </div>

                    <SectionTable title="Assessments" count={location.state?.assessments?.length}>
                        <table className="w-full">
                            <thead>
                                <tr className="bg-gray-50/80">
                                    {["Title", "Category", "Type", "Status", "Created"].map((col, i) => (
                                        <th
                                            key={col}
                                            className={`text-xs font-medium text-gray-400 tracking-wider uppercase px-6 py-3 ${i === 4 ? "text-right" : "text-left"}`}
                                        >
                                            {col}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {location.state?.assessments?.length > 0 ? (

                                    location.state?.assessments && location.state?.assessments.map((row) => (
                                        <tr
                                            key={row.id}
                                            className="hover:bg-gray-50/60 transition-colors cursor-pointer"
                                            onMouseEnter={() => setHovered(`a-${row.id}`)}
                                            onMouseLeave={() => setHovered(null)}
                                        >
                                            <td className="px-6 py-4 text-sm font-medium text-gray-800">{row.title}</td>
                                            <td className="px-6 py-4 text-sm text-gray-400">{row.type}</td>
                                            <td className="px-6 py-4">
                                                <span
                                                    className="text-xs text-gray-500 bg-gray-100 border border-gray-200 px-2 py-0.5 rounded"
                                                    style={{ fontFamily: "'DM Mono', monospace" }}
                                                >
                                                    {row.sub_type}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <StatusBadge status={row.status} />
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-400 text-right"> {row.created_at ? moment(row.created_at).format('MMM DD, YYYY') : '-'}</td>
                                        </tr>
                                    ))
                                )

                                    : (
                                        <tr>
                                            <td colSpan={5} className="px-6 py-10 text-sm text-center text-gray-400">
                                                No assessments created by this creator.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </SectionTable>

                    <SectionTable title="Courses" count={location.state?.courses?.length}>
                        <table className="w-full">
                            <thead>
                                <tr className="bg-gray-50/80">
                                    <th className="w-8/12 text-xs font-medium text-gray-400 tracking-wider uppercase px-6 py-3 text-left">
                                        Title
                                    </th>
                                    <th className="w-2/12 text-xs font-medium text-gray-400 tracking-wider uppercase px-6 py-3 text-center">
                                        Status
                                    </th>
                                    <th className="w-2/12 text-xs font-medium text-gray-400 tracking-wider uppercase px-6 py-3 text-right">
                                        Created
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {location.state?.courses?.length > 0 ? (
                                    location.state.courses.map((row) => (
                                        <tr
                                            key={row.id}
                                            className="hover:bg-gray-50/60 transition-colors cursor-pointer"
                                        >
                                            <td className="w-8/12 px-6 py-4 text-sm font-medium text-gray-800">
                                                {row.title}
                                            </td>

                                            <td className="w-2/12 px-6 py-4 text-center">
                                                <StatusBadge status={row.status} />
                                            </td>

                                            <td className="w-2/12 px-6 py-4 text-sm text-gray-400 text-right">
                                                {row.created_at
                                                    ? moment(row.created_at).format('MMM DD, YYYY')
                                                    : '-'}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} className="px-6 py-10 text-sm text-center text-gray-400">
                                            No courses created by this creator.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </SectionTable>
                </div>
            </div>

            <Modal
                title="Edit Content Creator"
                open={modalOpen}
                toggle={() => setModalOpen(false)}
            >
                <AddContentWriterForm
                    mode="edit"
                    data={name}
                    toggle={() => setModalOpen(false)}
                    getClientList={() => { }}
                    existingClients={[]}
                    cominfrom='View'
                    updateDetails={(data) => updateDetails(data)}
                />
            </Modal>

            <DeactivateModal
                open={deactivateAlert}
                userName={`${location.state.first_name} ${location.state.last_name}`}
                onConfirm={handleDeactivate}
                onCancel={() => setDeactivateAlert(false)}
            />

            <SnackBar
                open={openSnackbar}
                snackbarTitle={snackbarTitle}
                close={() => setOpenSnackbar(false)}
            />
        </Page>
    );
}